import { Theme } from "design-system/utils/theme";
import { Link } from "design-system/components/primitives/link/link";
import { MouseEventHandler, useLayoutEffect, useRef, useState } from "react";
import { DataLayerEvent, useDataLayer } from "frontend/hooks/use-data-layer";

export interface CarouselCardProps {
  title: string;
  dek?: string;
  meta?: string;
  link?: string;
  theme?: Theme;
  onClick?: MouseEventHandler;
  dataLayer?: DataLayerEvent;
}

export function TeaseCarouselCard({
  title,
  dek,
  meta,
  link,
  theme: originalTheme = "blue",
  onClick,
  dataLayer,
}: CarouselCardProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const [theme, setTheme] = useState<Theme>(originalTheme);
  const { pushDataLayer } = useDataLayer();

  useLayoutEffect(() => {
    if (ref.current) {
      const closestParentWithTheme = ref.current.closest("[data-theme]");
      const parentTheme = closestParentWithTheme?.getAttribute("data-theme");

      if (parentTheme === theme) {
        setTheme("blue");
      }
    }
  }, [theme]);

  const handleOnClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    /* eslint-disable camelcase */
    if (dataLayer?.event === "info_box_item_click") {
      dataLayer.event_data.infobox_item_link_text = title;
      dataLayer.event_data.infobox_item_url = link;
    }
    /* eslint-enable camelcase */
    if (dataLayer) pushDataLayer(dataLayer);
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Link
      href={link}
      className="hbs-tease-carousel-card"
      ref={ref}
      dataLayer={dataLayer}
      onClick={handleOnClick}
    >
      <div className="hbs-tease-carousel-card__inner" data-theme={theme}>
        <h3 className="hbs-tease-carousel-card__title">{title}</h3>
        <p className="hbs-tease-carousel-card__dek">{dek}</p>
        <div className="hbs-tease-carousel-card__meta">
          <p>{meta}</p>
        </div>
      </div>
    </Link>
  );
}
